import React, {Component} from 'react';
import PropTypes from 'prop-types'

import {withStyles} from 'material-ui/styles';
import List from 'material-ui/List';
import ListSubheader from 'material-ui/List/ListSubheader';
import Avatar from 'material-ui/Avatar';

import _ from 'lodash';
import PlayerListItem from "./PlayerListItem";

const styles = {
  listSection: {
    background: '#d4d4d4',
    borderBottom: '1px solid #d4d4d4',
    borderTop: '1px solid #d4d4d4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'initial',
    paddingLeft: 12,
    paddingRight: 12
  },
  teamAvatar: {
    width: 52,
    height: 62,
    margin: '0 -6px'
  },
  listHeading: {
    color: '#333',
    fontSize: '13px',
    fontWeight: '800',
    paddingLeft: '18px',
    lineHeight: '20px'
  }
};

class PlayerList extends Component {

  componentDidMount() {
  }

  shouldComponentUpdate(nextProps, nextState) {
    return _.size(nextProps.players) !== _.size(this.props.players);
  }

  render() {
    const classes = this.props.classes;

    const teams = _.chain(this.props.players)
      .map(d => d.team)
      .uniqBy('id')
      .orderBy('name')
      .value();

    const teamPlayers = team => {
      return _.chain(this.props.players)
        .filter(d => d.team.id === team.id)
        .sortBy('name')
        .value()
    };

    return (
      <List dense subheader>
        {teams.map(team => (
          <div key={`team-${team.id}`}>
            <ListSubheader className={classes.listSection}>
              <Avatar
                className={classes.teamAvatar}
                alt={team.name}
                src={`http://cdn.nhle.com/logos/nhl/svg/${team.abbr}_light.svg?v=11.2`}/>
              <strong style={styles.listHeading}>{team.name}</strong>
            </ListSubheader>
            {teamPlayers(team).map(p => {
              return <PlayerListItem key={p.id} onClick={this.props.onClick} player={p}/>
            })}
          </div>
        ))}
      </List>
    )
  };
}

PlayerList.propTypes = {
  onClick: PropTypes.func.isRequired,
  players: PropTypes.array.isRequired,
  open: PropTypes.bool
};

export default withStyles(styles)(PlayerList)



// WEBPACK FOOTER //
// ./src/components/PlayerList.js